import { dataCalendar } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCalendar = /*#__PURE__*/createIcon(dataCalendar)
export default IconCalendar
